<template>
  <div class="w-full rounded-lg px-4 xl:px-0 flex flex-grow flex-col">
    <Chart />
  </div>
</template>

<script>
import Chart from '@/components/atoms/Chart.vue'
export default {
    components: {
        Chart
    }
}
</script>

<style>

</style>